/*
 * @Description:
 * @Version: 2.0销售合同有关语言包
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  新增飞书合同: '新增飞书合同',
  新建飞书合同: '新建飞书合同',
  新增烽火合同: '新增烽火合同',
  编辑烽火合同: '编辑烽火合同',
  基本信息: '基本信息',
  添加报价单明细: '添加报价单明细',
  添加明细: '添加明细',
  编辑合同明细: '编辑合同明细',
  添加合同明细: '添加合同明细',
  请选择报价单: '请选择报价单！',
  提交成功: '提交成功',
  合同明细: '合同明细',
  资料沉淀: '资料沉淀',
  审批中的销售合同不可作废: '审批中的销售合同不可作废',
  一个合同只能选择相同币种的价格: '一个合同只能选择相同币种的价格'
};
